// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/browser/pages/Authorized.scss
// module id = 1178
// module chunks = 0